import { useMemo } from 'react';
import type { IFieldsTab } from '@moko/utils';
import { useOtherInfoContext } from './OtherInfoContext';
import { FormArea } from './FormArea';
import { FieldList } from './FieldList';
import {
  MobileOtherInfoProvider,
  useMobileOtherInfo,
} from './MobileOtherInfo/MobileOtherInfoContext';
import { SectionHeader } from './MobileOtherInfo/SectionHeader';
import { NavigationView } from './MobileOtherInfo/NavigationView';

const DesktopTabContent = () => {
  const { params } = useOtherInfoContext();
  const { currentTab, tabs } = useMobileOtherInfo();
  const { fields } = params.metadata;

  const currentTabFields = useMemo(() => {
    if (tabs.length === 0) return fields;
    if (!currentTab) return [];
    return fields.filter((f) => f.tabName === currentTab.tabName);
  }, [fields, currentTab, tabs.length]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%',
      }}
    >
      <SectionHeader />
      <FieldList fields={currentTabFields} parentName="root" />
    </div>
  );
};

const DesktopOtherInfoInner = () => {
  const { params } = useOtherInfoContext();
  const { tabs } = useMobileOtherInfo();
  const hasTabs = tabs.length > 0;

  if (!hasTabs) {
    return (
      <FormArea>
        <FieldList fields={params.metadata.fields} parentName="root" />
      </FormArea>
    );
  }

  if (tabs.length === 1) {
    return (
      <FormArea>
        <DesktopTabContent />
      </FormArea>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        gap: 16,
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <div
        style={{
          flex: '0 0 360px',
          maxWidth: 360,
          position: 'sticky',
          top: 12,
        }}
      >
        <NavigationView fields={params.metadata.fields} isDesktop />
      </div>
      <FormArea style={{ flex: 1, minWidth: 0 }}>
        <DesktopTabContent />
      </FormArea>
    </div>
  );
};

export const DesktopOtherInfo = () => {
  const { params, effectsKey } = useOtherInfoContext();
  const tabs: IFieldsTab[] = useMemo(
    () => (params.metadata.tabs ?? []).filter((tab) => !tab.hidden),
    [params.metadata.tabs, effectsKey]
  );

  return (
    <MobileOtherInfoProvider tabs={tabs} fields={params.metadata.fields}>
      <DesktopOtherInfoInner />
    </MobileOtherInfoProvider>
  );
};
